import { Directive } from '@angular/core';
import { Validator, NG_VALIDATORS, AbstractControl } from '@angular/forms';
import { UserStub } from '../../../core-data-model/User.model';
import { StringUtilities } from '../../../core-utilities/String.utility';
import { UserFactory } from '../../../object-factory/User.factory';
import { InitDataService } from '../../../system-services/InitData/InitData.service';

@Directive({
    selector: '[validatePassword][ngModel],[validatePassword][formControl]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: PasswordValidatorDirective,
            multi: true
        }
    ],
    standalone: false
})
export class PasswordValidatorDirective implements Validator {
    user: UserStub;

    constructor(
        readonly initData: InitDataService,
        private userFactory: UserFactory
    ) {}
    validate(c: AbstractControl) {
        this.user = this.userFactory.new_UserStub({
            firstName: this.initData.user.firstName,
            lastName: this.initData.user.lastName,
            email: this.initData.user.email
        });
        return PasswordValidatorDirective.passwordValidation(c, this.user);
    }

    static passwordValidation(c: AbstractControl, user: object) {
        return PasswordValidatorDirective.rawPasswordValidation(c.value, user)
            ? null
            : {
                  validatePassword: {
                      valid: false
                  }
              };
    }

    static rawPasswordValidation(v: string, user: any) {
        if (!user || !v) return false;
        // Validating against user's name and email. Not validating against substrings of email though.
        if (
            v.toLowerCase().includes(user.firstName.toLowerCase()) ||
            v.toLowerCase().includes(user.lastName.toLowerCase()) ||
            v.toLowerCase().includes(user.email.toLowerCase())
        )
            return false;
        return StringUtilities.PASSWORD_REGEXP.test(v);
    }
}
